import api from '@/api'
import { defineStore } from 'pinia'
import { userStore } from './user'



export const jwtStore = defineStore('jwt', {
  state: () => ({
    jwt: '' as string,
    countRetest: 0 as number
  }),
  actions: {
    async setJwt(payload: string) {
      this.jwt = payload
      this.countRetest = 0
    },
    refreshJwt() {
      this.countRetest++
      return api.get('auth/refreshJwt')
    },
    async jwtLogout() {
      await this.setJwt('');
      localStorage.removeItem('jwt');
      const store = userStore()
      await store.userLogout();
    }
  },
  persist: {
    enabled: true,
    strategies: [
      {
        key: 'jwt',
        storage: localStorage,
      },
    ],
  }
})